import { createState, useState, none } from '@hookstate/core'
import { Persistence } from '@hookstate/persistence';
import { cloneDeep, assign } from 'lodash';

import { CompanyIInfo, CompanyManager } from '../config/interfaces';

const initialState: CompanyIInfo = {
  company_managers: [],
};

const companyInfoState = createState(initialState);
companyInfoState.attach(Persistence('companyInfo'));

export const initialStateCompanyInfo = () => {
  companyInfoState.set(initialState);
}

export const setCompanyInfo = (companyInfo: CompanyIInfo) => {
  const tempCompanyInfo = cloneDeep(companyInfo);
  tempCompanyInfo.company_managers.forEach((element) => {
    assign(element, { checked: false })
  });
  companyInfoState.set({
    ...initialState,
    ...companyInfo,
    company_managers: [...tempCompanyInfo.company_managers],
  });
};

export const setAddCompanyManager = (companyManager: CompanyManager) => {
  companyInfoState.company_managers[companyInfoState.company_managers.length].set(companyManager);
};

export const delCompanyManager = (idx: number) => {
  companyInfoState.company_managers[idx].set(none);
};

export const useCompanyInfoState = () => useState(companyInfoState);
